<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 330 100">
    <title>logo_default</title>
    <g id="レイヤー_2" style="fill: #ffffff" data-name="レイヤー 2">
      <g id="レイヤー_1-2" data-name="レイヤー 1">
        <path
          d="M28,90.3c7.9,0,14.3-3.5,14.3-14.4V68.1c-2.1,4.9-8.6,10-17.7,10C14.7,78.2,0,72.8,0,50.8,0,34.1,10.4,23.6,24.6,23.6c9.2,0,15.4,5.3,17.9,10.2V24.9H56.3V74.2C56.3,91.7,45.2,100,28,100,11.1,100,2.8,92.2,1.2,83h14C16.7,87.6,20.4,90.3,28,90.3ZM28.3,68c9.1,0,14.5-6.8,14.5-17.4v-1c0-10.3-6.6-16-14.5-16C19.4,33.6,14,40.3,14,50.8c0,5.3,1.3,9.5,3.8,12.6A13,13,0,0,0,28.3,68Z"
        />
        <rect x="70.3" y="4.5" width="14.9" height="13.5" />
        <rect x="70.8" y="24.9" width="14.1" height="54.7" />
        <path
          d="M106.1,79.6V34.8H98.4V24.9h7.7V17.1c0-11.2,6.7-17.2,18.2-17.1,1.8,0,3,0,4.3.1a15.83,15.83,0,0,1,3.8.5V11l-2.6-.3c-.9,0-1.8-.1-2.8-.1-2.3,0-4.1.6-5.2,1.8a7.37,7.37,0,0,0-1.7,5.3v7.1h11.3v9.9H120.1V79.5h-14Z"
        />
        <path
          d="M167.9,69.3a26.52,26.52,0,0,0,7.4-1.1V78.7a34.7,34.7,0,0,1-11.1,1.6c-11.8,0-17.4-5-17.4-15.8V34.8h-7.7V24.9h7.7V11.2h14V24.9h13.3v9.9H160.7V62.5C160.7,68,163.7,69.3,167.9,69.3Z"
        />
        <path
          d="M221.9,62.5h13c-2.3,11.6-11.2,18.3-25.1,18.3-9.1,0-15.5-2.6-20.4-7.7-4.7-4.9-7.8-11.8-7.8-20.8,0-17.4,11.6-28.7,27.9-28.7,10.9,0,19.2,5.5,23,13.9,2.2,5,3.1,10.8,2.9,18.1H195.2c0,5.1.9,7.1,2.9,10,1.8,2.7,6.1,5,11.8,5a14.14,14.14,0,0,0,8-2.1A12.52,12.52,0,0,0,221.9,62.5ZM209.1,33.8c-7.3,0-13,4.4-13.5,12.8h26.2C221.8,38.9,216.7,33.8,209.1,33.8Z"
        />
        <path
          d="M281.9,62.5h13c-2.3,11.6-11.2,18.3-25.1,18.3-9.1,0-15.5-2.6-20.4-7.7-4.7-4.9-7.8-11.8-7.8-20.8,0-17.4,11.6-28.7,27.9-28.7,10.9,0,19.2,5.5,23,13.9,2.2,5,3.1,10.8,2.9,18.1H255.2c0,5.1.9,7.1,2.8,10,1.8,2.7,6.1,5,11.8,5a14.14,14.14,0,0,0,8-2.1A12,12,0,0,0,281.9,62.5ZM269.1,33.8c-7.3,0-13,4.4-13.5,12.8h26.3C281.8,38.9,276.7,33.8,269.1,33.8Z"
        />
        <path
          d="M329.28,18.2c-3,1-11,3.6-13,4.1A107.65,107.65,0,0,0,318,9.6a9.94,9.94,0,0,0-7.2,0,107.65,107.65,0,0,0,1.7,12.7c-2-.5-9.9-3.1-13-4.1a15.3,15.3,0,0,0-.8,6,66.94,66.94,0,0,0,12.6,2.5A54.59,54.59,0,0,0,301,36.2c1.8,1.2,4.8,3.3,7.1,4.8a81.63,81.63,0,0,1,6.2-11.2,72.23,72.23,0,0,1,6.2,11.2c2.3-1.5,5.4-3.5,7.1-4.8a54.59,54.59,0,0,0-10.3-9.5,76,76,0,0,0,12.6-2.5C330.18,23,329.88,19.2,329.28,18.2Z"
          style="fill: #ffffff"
        />
      </g>
    </g>
  </svg>
</template>
